import { createSlice } from "@reduxjs/toolkit";
import { getfacebookCreativeList } from "./ThunkActions";
import {  REDUCER_NAME, IFacebookCreativeState } from "./Types";

// Define initial state based on the provided structure
const initialState: IFacebookCreativeState = {
  isLoading: false,
  facebookCreativeList: [],
  errorMessage: null,
};

export const facebookAdsetSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetfacebookAdsState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getfacebookCreativeList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getfacebookCreativeList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.facebookCreativeList = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(getfacebookCreativeList.rejected, (state) => {
        state.errorMessage = "Failed to fetch Creative list";
        state.isLoading = false;
      });
  },
});

export const { resetfacebookAdsState } = facebookAdsetSlice.actions;
export default facebookAdsetSlice.reducer;
